export default __webpack_public_path__ + "static/media/edit_rollover.70772aae.PNG";